<template>
  <NuxtLink :to="path" :title="title">
    <div class="tw-relative">
      <BadgeRecommended
        v-if="recommended"
        class="!tw-left-0"
        color="negative"
      />
      <MediaImageLazyLoad
        class="tw-relative tw-w-full tw-h-auto tw-rounded-lg tw-overflow-hidden tw-mb-3"
        :src="image?.medium || ''"
        :blank-src="image?.tiny || ''"
        :alt="title"
        aspect="1:1"
        seo-optimize
      />
    </div>
    <component
      :is="titleTag"
      v-if="title"
      class="tw-mb-2 tw-text-mb-title-5 lg:tw-text-dt-title-5 tw-line-clamp-2 tw-text-black"
    >
      {{ title }}
    </component>
    <div class="tw-mt-2">
      <DisplayPrice
        :options="options"
        :show-option-list="showOptionList"
        :min-price-option="minPriceOption"
        :max-price-option="maxPriceOption"
        :min-price-of-discounted-option="minPriceOfDiscountedOption"
        :max-price-of-discounted-option="maxPriceOfDiscountedOption"
        :price="price"
        :price-of-discounted="priceOfDiscounted"
        single-product-discount-container-class="tw-flex-row tw-gap-x-2 tw-items-center"
      />
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    image: ImageMeta;
    path?: string;
    title?: string;
    price?: number;
    priceOfDiscounted?: number;
    maxPriceOption?: number;
    minPriceOption?: number;
    minPriceOfDiscountedOption?: number;
    maxPriceOfDiscountedOption?: number;
    options?: ProductOption[];
    showOptionList?: boolean;
    recommended?: boolean;
    titleTag?: string;
  }>(),
  {
    path: "",
    title: "",
    price: 0,
    priceOfDiscounted: 0,
    maxPriceOption: 0,
    minPriceOption: 0,
    minPriceOfDiscountedOption: 0,
    maxPriceOfDiscountedOption: 0,
    options: () => [],
    showOptionList: true,
    recommended: false,
    titleTag: "h3",
  },
);
</script>
